import { useLayout } from '@/layout/LayoutProvider';
import { ReactNode, useEffect } from 'react';
import { Route, Routes, RoutesProps, useLocation } from 'react-router-dom';
import { Path, RebrandedPaths } from '../../../router/routes';
import { useFeatureToggles } from '../../../utils/unleash';
import { NotFound } from './NotFound';

/**
 * A Router wrapper that calls calls a layout hook to update rebrand value on location change.
 * Also includes a fallback not found route.
 */
const AppRouter = ({
  children,
  ...props
}: { children: ReactNode } & RoutesProps) => {
  const location = useLocation();
  const featureToggles = useFeatureToggles();
  const isRebrandCustomer = featureToggles.USE_REBRANDED_ASSETS;
  const { setIsRebrand } = useLayout();

  useEffect(() => {
    // exact match on overview page to avoid TMC rebranding for now (/skadesaker/{ref})
    const isOverViewPage = location.pathname === Path.OVERVIEW;
    const isRebrandPath =
      isOverViewPage ||
      RebrandedPaths.some((path: Path) => location.pathname.includes(path));

    const showRebrand = isRebrandCustomer && isRebrandPath;

    setIsRebrand(showRebrand);
  }, [isRebrandCustomer, location.pathname, setIsRebrand]);

  return (
    <Routes {...props}>
      {children}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AppRouter;
